<template>
	<v-dialog
		v-model="mValue"
		:fullscreen="$vuetify.breakpoint.xs"
		width="95%"
		max-width="800px"
	>
		<v-card>
			<v-card-title class="d-flex flex-nowrap pl-4 pr-2">
				<div class="flex-grow-1 font-weight-bold d-flex align-center flex-wrap">{{ title }}</div>
				<v-btn icon class="ml-2 align-self-start flex-shrink-0" @click="mValue = false">
					<v-icon>fa fa-times</v-icon>
				</v-btn>
			</v-card-title>
		</v-card>

		<QApplicationPdfPreview
			v-if="mValue"
			:application="application"
			:secure="secure"
			@hide="mValue = false"
		/>
	</v-dialog>
</template>

<script>
import QApplicationPdfPreview from '@/components/utils/QApplicationPdfPreview.vue'

export default {
    components: {
		QApplicationPdfPreview,
    },
	props: {
		value: { type: Boolean, default: false },
		application: { type: Object, default: () => ({}) },
		secure: { type: [Boolean, Object], default: false },
		title: { type: String, default: 'Preview PDF' },
	},
	computed: {
		mValue: {
			get () { return this.value },
			set (val) { this.$emit('input', val) },
		},
	},
}
</script>
